export default "__VITE_ASSET__a1999c25__"